//const baseUrl = "http://192.168.168.57:8080/mechanichunt/";
const baseUrl = "https://api.mechanichunt.com/"

const BaseUrl={
    baseUrl
};

export default BaseUrl;